import { useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import { motion, AnimatePresence } from "framer-motion";
import "@/App.css";

import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { EditorialMarquee } from "@/components/site/Marquee";
import { MenuSection } from "@/components/site/MenuSection";
import { Manifesto } from "@/components/site/Manifesto";
import { Footer } from "@/components/site/Footer";

const LoadingCurtain = ({ done }) => (
  <AnimatePresence>
    {!done && (
      <motion.div
        key="curtain"
        initial={{ y: 0 }}
        exit={{ y: "-101%" }}
        transition={{ duration: 1.1, ease: [0.76, 0, 0.24, 1], delay: 0.2 }}
        className="fixed inset-0 z-[200] bg-ink flex items-end justify-between px-6 md:px-12 pb-12"
        data-testid="loading-curtain"
      >
        <motion.span
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="font-serif italic text-bone/80 text-2xl md:text-4xl tracking-tightest"
        >
          Ferrum <span className="text-gold">&amp;</span> Ember
        </motion.span>
        <motion.span
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.35 }}
          className="text-[11px] uppercase tracking-widest-2 text-bone/40"
        >
          brewing the page…
        </motion.span>
      </motion.div>
    )}
  </AnimatePresence>
);

function App() {
  const [ready, setReady] = useState(false);
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      lerp: 0.09,
      smoothWheel: true,
      wheelMultiplier: 0.9,
    });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    const t = setTimeout(() => setReady(true), 1400);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="App grain vignette relative bg-ink text-bone">
      <LoadingCurtain done={ready} />
      <Nav />
      <main>
        <Hero />
        <EditorialMarquee />
        <MenuSection />
        <Manifesto />
      </main>
      <Footer />
    </div>
  );
}

export default App;
